
import "./radio-v1"
import "./checkbox-v1"
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutProductCardV2 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}

mount() {
    this.can_purchase_again = !(new URLSearchParams(window.location.search).get('manage_order_id'))

    this.variantValues = Object.entries(this.product.property_values_variant_mapping ?? {}).reduce((acc, entries) => {
      const values = entries[0].split(',').map((value) => parseInt(value))
      acc[entries[1]] = values
      return acc
    }, {}) ?? {}

    this.valuesPositions = this.product.sorted_property_values?.reduce((acc, property) => {
      property.value_ids.forEach((value, index) => {
        acc[value] = index
      })
      return acc
    }, {}) ?? {}

  }


    remove() {
      this.element.innerHTML = '';
    }
    render(initializeChildrenInstances = false) {
      const is_server = true;
      const layout = this.layout ?? null ;
const featured = this.featured ?? null ;
const highlight_text = this.highlight_text ?? null ;
const selectType = this.selectType ?? null ;
const showImage = this.showImage ?? null ;
const showDescription = this.showDescription ?? null ;
const showCompareAtPrice = this.showCompareAtPrice ?? null ;
const isChecked = this.isChecked ?? null ;
const product = this.product ?? null ;
const variantDisplay = this.variantDisplay ?? null ;
const individualVariantId = this.individualVariantId ?? null ;
const variant = this.variant ?? null ;
const selected_price = this.selected_price ?? null ;
const quantity = this.quantity ?? null ;
const otherTexts = this.otherTexts ?? null ;
const can_purchase_again = this.can_purchase_again ?? true ;
const renderType = this.renderType ?? null ;
const selectedOrderIndex = this.selectedOrderIndex ?? null ;
const selectedUpdatableCartItemIndex = this.selectedUpdatableCartItemIndex ?? null ;
const updatableOrders = this.updatableOrders ?? null ;
const individualDirection = this.individualDirection ?? null ;

      
      let html = '';
      {
        const is_not_server = false;
        let priceDisplayType = "multiple";
        let newOrder = selectedOrderIndex == -1;
        let showProductVariantSelection = true;
        let currentRenderType = renderType;
        const showUpgradeDowngrade = currentRenderType == "upgradeDowngrade";
        const showReactivate = currentRenderType == "reactivate";
        const showManageOrders = showUpgradeDowngrade || showReactivate;
        if (showManageOrders) {
          showProductVariantSelection = false;
          if (showUpgradeDowngrade) {
            priceDisplayType = "hide";
            if (newOrder && variant?.prices?.length == 1) {
              priceDisplayType = "single";
            }
          }
          if (showReactivate && variant?.prices?.length > 1) {
            priceDisplayType = "single";
          }
        }
        const customVariants = product?.variants.filter((value) => value["default_variant"] == false);
        if (layout == "modern") {
          html += `<div class="elProductLayoutBackground"></div>`
          html += `<div class="elProductModernItem"> `
          if (selectType == "quantity") {
            html += `<div class="elProductInputWrapper elProductCardQuantityContainer"><div class="elProductInputControls"><button class="elProductCardInput">-</button><input class="elProductCardInput elProductCardShortInput" name="product" value="${quantity ?? 0}" min="0" type="number"/><button class="elProductCardInput">+</button></div></div>`
          } else if (selectType == "quantity-forced") {
            html += `<div class="elProductInputWrapper elSelectWrapper elForcedQuantityWrapper"><select name="product" class="elProductCardInput elProductInputControls">`
            const step = product?.step ?? 2;
            const min = product?.min ?? 0;
            const max = product?.max ?? 5;
            const item_count_step_1 = max- min;
            const item_count_step_2 = item_count_step_1/ step;
            const item_count_step_3 = item_count_step_2| 0;
            const range = Array.apply(0, Array(item_count_step_3)).map((element, index) => index + 0);;
            const c0 = range
            const fl1 = new CF2ForloopDrop(c0.length)
            for (const i of c0) {
              const forloop = fl1
              const value = i* step+ min;
              html += `<option value="${value}">${value}</option>`
              forloop.next();
            }
            html += `</select><div class="elSelectArrow elForcedQuantitySelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
          }
          const isClassic = layout == "classic";
          const isQuantityType = selectType == "quantity";
          html += `<div class="elProductCardSelectInput`
          if (isClassic == false || isQuantityType == true) {
            html += ` hide`
          }
          html += `">`
          if (selectType == "single") {
            if (isChecked) {
              html += `<div data-page-element="Radio/V1" class="elRadioWrapper id-Radio/V1" data-liquid-replace="item" data-checked="true" data-trigger-click-on-wrapper="false"><label class="elRadioLabel"><input type="radio" value="" name="product" checked class="elRadioInput"/><div class="elRadio"><div class="elRadioIcon"></div></div><span class="elRadioText"></span></label></div>`
            } else {
              html += `<div data-page-element="Radio/V1" class="elRadioWrapper id-Radio/V1" data-liquid-replace="item" data-checked="" data-trigger-click-on-wrapper="false"><label class="elRadioLabel"><input type="radio" value="" name="product"  class="elRadioInput"/><div class="elRadio"><div class="elRadioIcon"></div></div><span class="elRadioText"></span></label></div>`
            }
          } else if (selectType == "multiple" || selectType == "quantity") {
            if (isChecked) {
              html += `<div data-page-element="Checkbox/V1" type="custom_type" class="elCheckboxWrapper elFormItemWrapper de-input-block id-Checkbox/V1" data-content="" data-liquid-replace="item" data-prevent-click-on-label="false" data-trigger-click-on-wrapper="false" data-checked="true"><label class="elCheckboxLabel"><input type="checkbox" value="${product?.id}" name="product" checked data-prevent-garlic="false" class="elCheckboxInput inputHolder"/><div class="elCheckbox"><div class="elCheckboxIcon"><div class="elCheckboxIconSquare hide"></div><i class="elCheckboxIconCheck fas fa-check"></i></div></div><span class="elCheckboxText"></span></label><div data-input-status-type="true" data-error-container="true"></div></div>`
            } else {
              html += `<div data-page-element="Checkbox/V1" type="custom_type" class="elCheckboxWrapper elFormItemWrapper de-input-block id-Checkbox/V1" data-content="" data-liquid-replace="item" data-prevent-click-on-label="false" data-trigger-click-on-wrapper="false" data-checked=""><label class="elCheckboxLabel"><input type="checkbox" value="${product?.id}" name="product"  data-prevent-garlic="false" class="elCheckboxInput inputHolder"/><div class="elCheckbox"><div class="elCheckboxIcon"><div class="elCheckboxIconSquare hide"></div><i class="elCheckboxIconCheck fas fa-check"></i></div></div><span class="elCheckboxText"></span></label><div data-input-status-type="true" data-error-container="true"></div></div>`
            }
          }
          html += `</div>`
          if (showImage) {
            const imageUrl = variant?.image ?? product.image;
            if (imageUrl && imageUrl != "") {
              html += `<div class="elProductCardImage"><div data-page-element="Image/V2" class="elImageWrapper de-image-block id-Image/V2`
              if (true && CF2Blank( imageUrl ) && CF2Blank( null ) && false == false) {
                html += ` forceHide`
              }
              html += `" data-liquid-replace="item">`
              if (imageUrl || !CF2Blank( null )) {
                html += `<img class="elImage" src="${imageUrl ?? null}" data-lazy-loading="true"/>`
              } else if (false) {
                html += `<div class="image-placeholder" title=""><span class="image-placeholder-header"></span></div>`
              }
              html += `</div></div>`
            }
          }
          html += `<div class="elProductCardNameContainer">`
          if (featured && highlight_text) {
            html += `<div class="elProductCardHighlight">${highlight_text}</div>`
          }
          if (variantDisplay == "individual") {
            html += `<span class="elProductCardInfoName">${variant?.name}</span>`
          } else if (customVariants?.length > 1) {
            html += `<span class="elProductCardInfoName">${product?.default_variant?.name}</span>`
          } else {
            html += `<span class="elProductCardInfoName">${variant?.name}</span>`
          }
          if (showDescription) {
            html += `<span class="elProductCardInfoDescription">${(product?.description_override ?? variant.description ?? product.default_variant.description ?? "").replaceAll(`
`,"<br>")}</span>`
          }
          html += `</div><div class="elProductCardPriceContainer">`
          if (priceDisplayType == "multiple") {
            if (variant?.prices?.length == 1) {
              html += `<div class="elProductCardInfoPrice">`
              if (showCompareAtPrice) {
                const compare_at_amount = selected_price?.compare_at_amount;
                if (compare_at_amount) {
                  html += `<span class="elProductCardAnchorPrice">${compare_at_amount}</span>`
                }
              }
              html += `<span class="elProductCardFinalPrice">${selected_price?.name}</span></div>`
            } else {
              html += `<div class="elSelectWrapper"><select name="variant_price">`
              const c2 = variant.prices
              const fl3 = new CF2ForloopDrop(c2.length)
              for (const price of c2) {
                const forloop = fl3
                html += `<option `
                if (selected_price?.id == price?.id) {
                  html += `selected`
                }
                html += ` value="${price?.id}">${price?.name}</option>`
                forloop.next();
              }
              html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
            }
          } else if (priceDisplayType == "single") {
            html += `<div class="elProductCardInfoPrice">`
            if (showCompareAtPrice) {
              const compare_at_amount = selected_price?.compare_at_amount;
              if (compare_at_amount) {
                html += `<span class="elProductCardAnchorPrice">${compare_at_amount}</span>`
              }
            }
            html += `<span class="elProductCardFinalPrice">${selected_price?.name}</span></div>`
          }
          html += `</div>`
          if (showProductVariantSelection && variantDisplay != "individual") {
            if (customVariants?.length > 1) {
              html += `<div class="elProductSelectSelectorsWrapper">`
              const c4 = product.sorted_property_values
              const fl5 = new CF2ForloopDrop(c4.length)
              for (const property_values of c4) {
                const forloop = fl5
                const property_id = property_values?.property_id;
                const select_index = forloop?.index0;
                html += `    `
                html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                const c6 = property_values.value_ids
                const fl7 = new CF2ForloopDrop(c6.length)
                for (const value_id of c6) {
                  const forloop = fl7
                  html += `<option `
                  if (variant?.property_value_ids?.[select_index] == value_id) {
                    html += `selected`
                  }
                  html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                  forloop.next();
                }
                html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                forloop.next();
              }
              html += `</div>`
            }
          }
          if (showManageOrders) {
            const amount_of_orders = updatableOrders?.length;
            if (amount_of_orders && amount_of_orders > 0) {
              if (variantDisplay == "individual") {
                const isCurrentPlan = individualDirection == "current";
                if (isCurrentPlan) {
                  html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i><span>Current plan</span>`
                  if (can_purchase_again) {
                    html += `<span class="elProductCardCurrentPlanSeparator">-</span>`
                    html += `<div class="elProductCardNewOrder elProductCardPurchaseAgainInline"><span>Purchase Again</span></div>`
                  }
                  html += `</div>`
                } else {
                  html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i><span>${individualDirection}</span></div>`
                  html += `<div class="elProductCardManageOrders`
                  if (CF2Blank( isChecked )) {
                    html += ` elHide`
                  }
                  html += `"><div class="elProductCardOrdersWrapper"><div class="elProductCardTitle"><span>${individualDirection} </span><div></div></div><div class="elProductCardOrders">`
                  const c8 = updatableOrders
                  const fl9 = new CF2ForloopDrop(c8.length)
                  for (const order of c8) {
                    const forloop = fl9
                    const orderIndex = forloop?.index0;
                    html += `<div class="elProductCardOrder`
                    if (selectedOrderIndex == orderIndex) {
                      html += ` elProductCardOrderSelected`
                    }
                    html += `" data-order-index="${orderIndex}"><div class="elProductCardOrderDetails"><div class="elProductCardOrderDetailsNumber"><i class="fas fa-receipt"></i><span>${otherTexts?.upgradesDowngradesReactivations?.order} ${order?.number}</span></div><span class="elProductCardOrderDetailsManage">${individualDirection}</span></div>`
                    if (selectedOrderIndex == orderIndex) {
                      html += `<div class="elProductCardOrderActions"><a data-page-element="LinkNode" class="elTypographyLink elProductCardShowOrderDetailsLink id-LinkNode" href="#show-selected-order-details" target="_self" data-show-button-ids="" data-hide-button-ids="" data-selected="${false}" data-liquid-replace="item"><span>${otherTexts?.upgradesDowngradesReactivations?.viewOrderDetails}</span></a><span class="elProductCardDirectionBadge">${individualDirection}  ${variant?.name} - ${selected_price?.name}</span></div>`
                    }
                    html += `</div>`
                    forloop.next();
                  }
                  html += `</div></div>`
                  if (can_purchase_again) {
                    html += `<div class="elProductCardNewOrderWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.purchaseAgain}</span><div></div></div><div class="elProductCardNewOrder`
                    if (newOrder == true) {
                      html += ` elProductCardOrderSelected`
                    }
                    html += `"><div class="elProductCardNewOrderTitle"><i class="fas fa-plus-circle"></i><span>${otherTexts?.upgradesDowngradesReactivations?.newOrder}</span></div>`
                    if (newOrder == true) {
                      html += `<div class="elProductCardOrderActions">`
                      if (variantDisplay != "individual") {
                        if (customVariants?.length > 1) {
                          html += `<div class="elProductSelectSelectorsWrapper">`
                          const c10 = product.sorted_property_values
                          const fl11 = new CF2ForloopDrop(c10.length)
                          for (const property_values of c10) {
                            const forloop = fl11
                            const property_id = property_values?.property_id;
                            const select_index = forloop?.index0;
                            html += `    `
                            html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                            const c12 = property_values.value_ids
                            const fl13 = new CF2ForloopDrop(c12.length)
                            for (const value_id of c12) {
                              const forloop = fl13
                              html += `<option `
                              if (variant?.property_value_ids?.[select_index] == value_id) {
                                html += `selected`
                              }
                              html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                              forloop.next();
                            }
                            html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                            forloop.next();
                          }
                          html += `</div>`
                        }
                      }
                      if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                        const c14 = variant.prices
                        const fl15 = new CF2ForloopDrop(c14.length)
                        for (const price of c14) {
                          const forloop = fl15
                          html += `<option `
                          if (selected_price?.id == price?.id) {
                            html += `selected`
                          }
                          html += ` value="${price?.id}">${price?.name}</option>`
                          forloop.next();
                        }
                        html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                      }
                      html += `</div>`
                    }
                    html += `</div></div>`
                  }
                  html += `</div>`
                }
              } else {
                let active_order = false;
                let canceled_order = false;
                const amount_of_orders = updatableOrders?.length;
                const c16 = updatableOrders
                const fl17 = new CF2ForloopDrop(c16.length)
                for (const order of c16) {
                  const forloop = fl17
                  if (order?.type == "reactivate") {
                    canceled_order = true;
                  } else {
                    active_order = true;
                  }
                  forloop.next();
                }
                html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i>`
                if (active_order && canceled_order) {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.multipleExistingSubscriptions}</span>`
                  } else {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.singleExistingSubscription}</span>`
                  }
                } else if (canceled_order) {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} </span>`
                  } else {
                    html += `<span>${amount_of_orders} </span>`
                  }
                } else {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.multipleActiveSubscriptions}</span>`
                  } else {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.singleActiveSubscription}</span>`
                  }
                }
                html += `</div>`
                html += `<div class="elProductCardManageOrders`
                if (CF2Blank( isChecked )) {
                  html += ` elHide`
                }
                html += `"><div class="elProductCardOrdersWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.manageSubscriptions}</span><div></div></div><div class="elProductCardOrders">`
                const c18 = updatableOrders
                const fl19 = new CF2ForloopDrop(c18.length)
                for (const order of c18) {
                  const forloop = fl19
                  const orderIndex = forloop?.index0;
                  html += `<div class="elProductCardOrder`
                  if (selectedOrderIndex == orderIndex) {
                    html += ` elProductCardOrderSelected`
                  }
                  html += `" data-order-index="${orderIndex}"><div class="elProductCardOrderDetails"><div class="elProductCardOrderDetailsNumber"><i class="fas fa-receipt"></i><span>${otherTexts?.upgradesDowngradesReactivations?.order} ${order?.number}</span></div>`
                  if (order?.type == "reactivate") {
                    html += `<span class="elProductCardOrderDetailsReactivate"></span>`
                  } else {
                    html += `<span class="elProductCardOrderDetailsManage">${otherTexts?.upgradesDowngradesReactivations?.manage}</span>`
                  }
                  html += `</div>`
                  if (selectedOrderIndex == orderIndex) {
                    html += `<div class="elProductCardOrderActions"><a data-page-element="LinkNode" class="elTypographyLink elProductCardShowOrderDetailsLink id-LinkNode" href="#show-selected-order-details" target="_self" data-show-button-ids="" data-hide-button-ids="" data-selected="${false}" data-liquid-replace="item"><span>${otherTexts?.upgradesDowngradesReactivations?.viewOrderDetails}</span></a>`
                    if (order?.type == "upgradeDowngrade") {
                      const updatableItem = order?.updatableItems?.[selectedUpdatableCartItemIndex];
                      html += `<div class="elCustomSelect"><div class="elCustomSelectPreview"><span class="elCustomSelectPreviewText"><span class="elCustomSelectPreviewDirection" data-direction="${updatableItem?.direction}">${updatableItem?.direction} </span><span class="elCustomSelectPreviewInfo">${updatableItem?.variantName} - ${updatableItem?.priceName}</span></span><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div><select name="upgradeDowngrade">`
                      const c20 = order.updatableItems
                      const fl21 = new CF2ForloopDrop(c20.length)
                      for (const updatableItem of c20) {
                        const forloop = fl21
                        const index = forloop?.index0;
                        html += `<option `
                        if (index == selectedUpdatableCartItemIndex) {
                          html += `selected`
                        }
                        html += ` value="${index}">${updatableItem?.direction}  ${updatableItem?.variantName} - ${updatableItem?.priceName}</option>`
                        forloop.next();
                      }
                      html += `</select></div>`
                    } else {
                      if (customVariants?.length > 1) {
                        html += `<div class="elCustomSelect"><div class="elCustomSelectPreview"><span class="elCustomSelectPreviewText"><span class="elCustomSelectPreviewDirection" data-direction="Reactivate"></span><span class="elCustomSelectPreviewInfo">${variant?.name}</span></span><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div><select class="elVariantSelector">`
                        const c22 = product.variants
                        const fl23 = new CF2ForloopDrop(c22.length)
                        for (const product_variant of c22) {
                          const forloop = fl23
                          let combined_variant_name = "";
                          const c24 = product.sorted_property_values
                          const fl25 = new CF2ForloopDrop(c24.length)
                          for (const property_values of c24) {
                            const forloop = fl25
                            const index0 = forloop?.index0;
                            const property_id = property_values?.property_id;
                            const property_value_id = product_variant?.property_value_ids?.[index0];
                            if (combined_variant_name != "") {
                              combined_variant_name = combined_variant_name.toString().concat(", ");
                            }
                            combined_variant_name = combined_variant_name.toString().concat(product.all_properties[property_id]);
                            combined_variant_name = combined_variant_name.toString().concat(": ");
                            combined_variant_name = combined_variant_name.toString().concat(product.all_properties_values[property_value_id]);
                            forloop.next();
                          }
                          html += `<option value="${product_variant?.property_value_ids}" `
                          if (product_variant?.id == variant?.id) {
                            html += `selected`
                          }
                          html += `>${combined_variant_name}</option>`
                          forloop.next();
                        }
                        html += `</select></div>`
                      }
                      if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                        const c26 = variant.prices
                        const fl27 = new CF2ForloopDrop(c26.length)
                        for (const price of c26) {
                          const forloop = fl27
                          html += `<option `
                          if (selected_price?.id == price?.id) {
                            html += `selected`
                          }
                          html += ` value="${price?.id}">${price?.name}</option>`
                          forloop.next();
                        }
                        html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                      }
                    }
                    html += `</div>`
                  }
                  html += `</div>`
                  forloop.next();
                }
                html += `</div></div>`
                if (can_purchase_again) {
                  html += `<div class="elProductCardNewOrderWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.purchaseAgain}</span><div></div></div><div class="elProductCardNewOrder`
                  if (newOrder == true) {
                    html += ` elProductCardOrderSelected`
                  }
                  html += `"><div class="elProductCardNewOrderTitle"><i class="fas fa-plus-circle"></i><span>${otherTexts?.upgradesDowngradesReactivations?.newOrder}</span></div>`
                  if (newOrder == true) {
                    html += `<div class="elProductCardOrderActions">`
                    if (variantDisplay != "individual") {
                      if (customVariants?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper">`
                        const c28 = product.sorted_property_values
                        const fl29 = new CF2ForloopDrop(c28.length)
                        for (const property_values of c28) {
                          const forloop = fl29
                          const property_id = property_values?.property_id;
                          const select_index = forloop?.index0;
                          html += `    `
                          html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                          const c30 = property_values.value_ids
                          const fl31 = new CF2ForloopDrop(c30.length)
                          for (const value_id of c30) {
                            const forloop = fl31
                            html += `<option `
                            if (variant?.property_value_ids?.[select_index] == value_id) {
                              html += `selected`
                            }
                            html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                            forloop.next();
                          }
                          html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                          forloop.next();
                        }
                        html += `</div>`
                      }
                    }
                    if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                      html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                      const c32 = variant.prices
                      const fl33 = new CF2ForloopDrop(c32.length)
                      for (const price of c32) {
                        const forloop = fl33
                        html += `<option `
                        if (selected_price?.id == price?.id) {
                          html += `selected`
                        }
                        html += ` value="${price?.id}">${price?.name}</option>`
                        forloop.next();
                      }
                      html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                    }
                    html += `</div>`
                  }
                  html += `</div></div>`
                }
                html += `</div>`
              }
            }
          }
          html += `</div>`
        } else if (layout == "grid") {
          html += `<div class="elProductLayoutBackground"></div>`
          html += `<div class="elProductGridItem">`
          if (selectType == "quantity") {
            html += `<div class="elProductInputWrapper elProductCardQuantityContainer"><div class="elProductInputControls"><button class="elProductCardInput">-</button><input class="elProductCardInput elProductCardShortInput" name="product" value="${quantity ?? 0}" min="0" type="number"/><button class="elProductCardInput">+</button></div></div>`
          } else if (selectType == "quantity-forced") {
            html += `<div class="elProductInputWrapper elSelectWrapper elForcedQuantityWrapper"><select name="product" class="elProductCardInput elProductInputControls">`
            const step = product?.step ?? 2;
            const min = product?.min ?? 0;
            const max = product?.max ?? 5;
            const item_count_step_1 = max- min;
            const item_count_step_2 = item_count_step_1/ step;
            const item_count_step_3 = item_count_step_2| 0;
            const range = Array.apply(0, Array(item_count_step_3)).map((element, index) => index + 0);;
            const c34 = range
            const fl35 = new CF2ForloopDrop(c34.length)
            for (const i of c34) {
              const forloop = fl35
              const value = i* step+ min;
              html += `<option value="${value}">${value}</option>`
              forloop.next();
            }
            html += `</select><div class="elSelectArrow elForcedQuantitySelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
          }
          const isClassic = layout == "classic";
          const isQuantityType = selectType == "quantity";
          html += `<div class="elProductCardSelectInput`
          if (isClassic == false || isQuantityType == true) {
            html += ` hide`
          }
          html += `">`
          if (selectType == "single") {
            if (isChecked) {
              html += `<div data-page-element="Radio/V1" class="elRadioWrapper id-Radio/V1" data-liquid-replace="item" data-checked="true" data-trigger-click-on-wrapper="false"><label class="elRadioLabel"><input type="radio" value="" name="product" checked class="elRadioInput"/><div class="elRadio"><div class="elRadioIcon"></div></div><span class="elRadioText"></span></label></div>`
            } else {
              html += `<div data-page-element="Radio/V1" class="elRadioWrapper id-Radio/V1" data-liquid-replace="item" data-checked="" data-trigger-click-on-wrapper="false"><label class="elRadioLabel"><input type="radio" value="" name="product"  class="elRadioInput"/><div class="elRadio"><div class="elRadioIcon"></div></div><span class="elRadioText"></span></label></div>`
            }
          } else if (selectType == "multiple" || selectType == "quantity") {
            if (isChecked) {
              html += `<div data-page-element="Checkbox/V1" type="custom_type" class="elCheckboxWrapper elFormItemWrapper de-input-block id-Checkbox/V1" data-content="" data-liquid-replace="item" data-prevent-click-on-label="false" data-trigger-click-on-wrapper="false" data-checked="true"><label class="elCheckboxLabel"><input type="checkbox" value="${product?.id}" name="product" checked data-prevent-garlic="false" class="elCheckboxInput inputHolder"/><div class="elCheckbox"><div class="elCheckboxIcon"><div class="elCheckboxIconSquare hide"></div><i class="elCheckboxIconCheck fas fa-check"></i></div></div><span class="elCheckboxText"></span></label><div data-input-status-type="true" data-error-container="true"></div></div>`
            } else {
              html += `<div data-page-element="Checkbox/V1" type="custom_type" class="elCheckboxWrapper elFormItemWrapper de-input-block id-Checkbox/V1" data-content="" data-liquid-replace="item" data-prevent-click-on-label="false" data-trigger-click-on-wrapper="false" data-checked=""><label class="elCheckboxLabel"><input type="checkbox" value="${product?.id}" name="product"  data-prevent-garlic="false" class="elCheckboxInput inputHolder"/><div class="elCheckbox"><div class="elCheckboxIcon"><div class="elCheckboxIconSquare hide"></div><i class="elCheckboxIconCheck fas fa-check"></i></div></div><span class="elCheckboxText"></span></label><div data-input-status-type="true" data-error-container="true"></div></div>`
            }
          }
          html += `</div>`
          if (showImage) {
            const imageUrl = variant?.image ?? product.image;
            if (imageUrl && imageUrl != "") {
              html += `<div class="elProductCardImage"><div data-page-element="Image/V2" class="elImageWrapper de-image-block id-Image/V2`
              if (true && CF2Blank( imageUrl ) && CF2Blank( null ) && false == false) {
                html += ` forceHide`
              }
              html += `" data-liquid-replace="item">`
              if (imageUrl || !CF2Blank( null )) {
                html += `<img class="elImage" src="${imageUrl ?? null}" data-lazy-loading="true"/>`
              } else if (false) {
                html += `<div class="image-placeholder" title=""><span class="image-placeholder-header"></span></div>`
              }
              html += `</div></div>`
            }
          }
          html += `<div class="elProductCardNamePriceWrapper"><div class="elProductCardNameContainer">`
          if (featured && highlight_text) {
            html += `<div class="elProductCardHighlight">${highlight_text}</div>`
          }
          if (variantDisplay == "individual") {
            html += `<span class="elProductCardInfoName">${variant?.name}</span>`
          } else if (customVariants?.length > 1) {
            html += `<span class="elProductCardInfoName">${product?.default_variant?.name}</span>`
          } else {
            html += `<span class="elProductCardInfoName">${variant?.name}</span>`
          }
          if (showDescription) {
            html += `<span class="elProductCardInfoDescription">${(product?.description_override ?? variant.description ?? product.default_variant.description ?? "").replaceAll(`
`,"<br>")}</span>`
          }
          html += `</div><div class="elProductCardPriceContainer">`
          if (priceDisplayType == "multiple") {
            if (variant?.prices?.length == 1) {
              html += `<div class="elProductCardInfoPrice">`
              if (showCompareAtPrice) {
                const compare_at_amount = selected_price?.compare_at_amount;
                if (compare_at_amount) {
                  html += `<span class="elProductCardAnchorPrice">${compare_at_amount}</span>`
                }
              }
              html += `<span class="elProductCardFinalPrice">${selected_price?.name}</span></div>`
            } else {
              html += `<div class="elSelectWrapper"><select name="variant_price">`
              const c36 = variant.prices
              const fl37 = new CF2ForloopDrop(c36.length)
              for (const price of c36) {
                const forloop = fl37
                html += `<option `
                if (selected_price?.id == price?.id) {
                  html += `selected`
                }
                html += ` value="${price?.id}">${price?.name}</option>`
                forloop.next();
              }
              html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
            }
          } else if (priceDisplayType == "single") {
            html += `<div class="elProductCardInfoPrice">`
            if (showCompareAtPrice) {
              const compare_at_amount = selected_price?.compare_at_amount;
              if (compare_at_amount) {
                html += `<span class="elProductCardAnchorPrice">${compare_at_amount}</span>`
              }
            }
            html += `<span class="elProductCardFinalPrice">${selected_price?.name}</span></div>`
          }
          html += `</div></div></div>`
          if (showProductVariantSelection && variantDisplay != "individual") {
            if (customVariants?.length > 1) {
              html += `<div class="elProductSelectSelectorsWrapper">`
              const c38 = product.sorted_property_values
              const fl39 = new CF2ForloopDrop(c38.length)
              for (const property_values of c38) {
                const forloop = fl39
                const property_id = property_values?.property_id;
                const select_index = forloop?.index0;
                html += `    `
                html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                const c40 = property_values.value_ids
                const fl41 = new CF2ForloopDrop(c40.length)
                for (const value_id of c40) {
                  const forloop = fl41
                  html += `<option `
                  if (variant?.property_value_ids?.[select_index] == value_id) {
                    html += `selected`
                  }
                  html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                  forloop.next();
                }
                html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                forloop.next();
              }
              html += `</div>`
            }
          }
          if (showManageOrders) {
            const amount_of_orders = updatableOrders?.length;
            if (amount_of_orders && amount_of_orders > 0) {
              if (variantDisplay == "individual") {
                const isCurrentPlan = individualDirection == "current";
                if (isCurrentPlan) {
                  html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i><span>Current plan</span>`
                  if (can_purchase_again) {
                    html += `<span class="elProductCardCurrentPlanSeparator">-</span>`
                    html += `<div class="elProductCardNewOrder elProductCardPurchaseAgainInline"><span>Purchase Again</span></div>`
                  }
                  html += `</div>`
                } else {
                  html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i><span>${individualDirection}</span></div>`
                  html += `<div class="elProductCardManageOrders`
                  if (CF2Blank( isChecked )) {
                    html += ` elHide`
                  }
                  html += `"><div class="elProductCardOrdersWrapper"><div class="elProductCardTitle"><span>${individualDirection} </span><div></div></div><div class="elProductCardOrders">`
                  const c42 = updatableOrders
                  const fl43 = new CF2ForloopDrop(c42.length)
                  for (const order of c42) {
                    const forloop = fl43
                    const orderIndex = forloop?.index0;
                    html += `<div class="elProductCardOrder`
                    if (selectedOrderIndex == orderIndex) {
                      html += ` elProductCardOrderSelected`
                    }
                    html += `" data-order-index="${orderIndex}"><div class="elProductCardOrderDetails"><div class="elProductCardOrderDetailsNumber"><i class="fas fa-receipt"></i><span>${otherTexts?.upgradesDowngradesReactivations?.order} ${order?.number}</span></div><span class="elProductCardOrderDetailsManage">${individualDirection}</span></div>`
                    if (selectedOrderIndex == orderIndex) {
                      html += `<div class="elProductCardOrderActions"><a data-page-element="LinkNode" class="elTypographyLink elProductCardShowOrderDetailsLink id-LinkNode" href="#show-selected-order-details" target="_self" data-show-button-ids="" data-hide-button-ids="" data-selected="${false}" data-liquid-replace="item"><span>${otherTexts?.upgradesDowngradesReactivations?.viewOrderDetails}</span></a><span class="elProductCardDirectionBadge">${individualDirection}  ${variant?.name} - ${selected_price?.name}</span></div>`
                    }
                    html += `</div>`
                    forloop.next();
                  }
                  html += `</div></div>`
                  if (can_purchase_again) {
                    html += `<div class="elProductCardNewOrderWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.purchaseAgain}</span><div></div></div><div class="elProductCardNewOrder`
                    if (newOrder == true) {
                      html += ` elProductCardOrderSelected`
                    }
                    html += `"><div class="elProductCardNewOrderTitle"><i class="fas fa-plus-circle"></i><span>${otherTexts?.upgradesDowngradesReactivations?.newOrder}</span></div>`
                    if (newOrder == true) {
                      html += `<div class="elProductCardOrderActions">`
                      if (variantDisplay != "individual") {
                        if (customVariants?.length > 1) {
                          html += `<div class="elProductSelectSelectorsWrapper">`
                          const c44 = product.sorted_property_values
                          const fl45 = new CF2ForloopDrop(c44.length)
                          for (const property_values of c44) {
                            const forloop = fl45
                            const property_id = property_values?.property_id;
                            const select_index = forloop?.index0;
                            html += `    `
                            html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                            const c46 = property_values.value_ids
                            const fl47 = new CF2ForloopDrop(c46.length)
                            for (const value_id of c46) {
                              const forloop = fl47
                              html += `<option `
                              if (variant?.property_value_ids?.[select_index] == value_id) {
                                html += `selected`
                              }
                              html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                              forloop.next();
                            }
                            html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                            forloop.next();
                          }
                          html += `</div>`
                        }
                      }
                      if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                        const c48 = variant.prices
                        const fl49 = new CF2ForloopDrop(c48.length)
                        for (const price of c48) {
                          const forloop = fl49
                          html += `<option `
                          if (selected_price?.id == price?.id) {
                            html += `selected`
                          }
                          html += ` value="${price?.id}">${price?.name}</option>`
                          forloop.next();
                        }
                        html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                      }
                      html += `</div>`
                    }
                    html += `</div></div>`
                  }
                  html += `</div>`
                }
              } else {
                let active_order = false;
                let canceled_order = false;
                const amount_of_orders = updatableOrders?.length;
                const c50 = updatableOrders
                const fl51 = new CF2ForloopDrop(c50.length)
                for (const order of c50) {
                  const forloop = fl51
                  if (order?.type == "reactivate") {
                    canceled_order = true;
                  } else {
                    active_order = true;
                  }
                  forloop.next();
                }
                html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i>`
                if (active_order && canceled_order) {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.multipleExistingSubscriptions}</span>`
                  } else {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.singleExistingSubscription}</span>`
                  }
                } else if (canceled_order) {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} </span>`
                  } else {
                    html += `<span>${amount_of_orders} </span>`
                  }
                } else {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.multipleActiveSubscriptions}</span>`
                  } else {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.singleActiveSubscription}</span>`
                  }
                }
                html += `</div>`
                html += `<div class="elProductCardManageOrders`
                if (CF2Blank( isChecked )) {
                  html += ` elHide`
                }
                html += `"><div class="elProductCardOrdersWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.manageSubscriptions}</span><div></div></div><div class="elProductCardOrders">`
                const c52 = updatableOrders
                const fl53 = new CF2ForloopDrop(c52.length)
                for (const order of c52) {
                  const forloop = fl53
                  const orderIndex = forloop?.index0;
                  html += `<div class="elProductCardOrder`
                  if (selectedOrderIndex == orderIndex) {
                    html += ` elProductCardOrderSelected`
                  }
                  html += `" data-order-index="${orderIndex}"><div class="elProductCardOrderDetails"><div class="elProductCardOrderDetailsNumber"><i class="fas fa-receipt"></i><span>${otherTexts?.upgradesDowngradesReactivations?.order} ${order?.number}</span></div>`
                  if (order?.type == "reactivate") {
                    html += `<span class="elProductCardOrderDetailsReactivate"></span>`
                  } else {
                    html += `<span class="elProductCardOrderDetailsManage">${otherTexts?.upgradesDowngradesReactivations?.manage}</span>`
                  }
                  html += `</div>`
                  if (selectedOrderIndex == orderIndex) {
                    html += `<div class="elProductCardOrderActions"><a data-page-element="LinkNode" class="elTypographyLink elProductCardShowOrderDetailsLink id-LinkNode" href="#show-selected-order-details" target="_self" data-show-button-ids="" data-hide-button-ids="" data-selected="${false}" data-liquid-replace="item"><span>${otherTexts?.upgradesDowngradesReactivations?.viewOrderDetails}</span></a>`
                    if (order?.type == "upgradeDowngrade") {
                      const updatableItem = order?.updatableItems?.[selectedUpdatableCartItemIndex];
                      html += `<div class="elCustomSelect"><div class="elCustomSelectPreview"><span class="elCustomSelectPreviewText"><span class="elCustomSelectPreviewDirection" data-direction="${updatableItem?.direction}">${updatableItem?.direction} </span><span class="elCustomSelectPreviewInfo">${updatableItem?.variantName} - ${updatableItem?.priceName}</span></span><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div><select name="upgradeDowngrade">`
                      const c54 = order.updatableItems
                      const fl55 = new CF2ForloopDrop(c54.length)
                      for (const updatableItem of c54) {
                        const forloop = fl55
                        const index = forloop?.index0;
                        html += `<option `
                        if (index == selectedUpdatableCartItemIndex) {
                          html += `selected`
                        }
                        html += ` value="${index}">${updatableItem?.direction}  ${updatableItem?.variantName} - ${updatableItem?.priceName}</option>`
                        forloop.next();
                      }
                      html += `</select></div>`
                    } else {
                      if (customVariants?.length > 1) {
                        html += `<div class="elCustomSelect"><div class="elCustomSelectPreview"><span class="elCustomSelectPreviewText"><span class="elCustomSelectPreviewDirection" data-direction="Reactivate"></span><span class="elCustomSelectPreviewInfo">${variant?.name}</span></span><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div><select class="elVariantSelector">`
                        const c56 = product.variants
                        const fl57 = new CF2ForloopDrop(c56.length)
                        for (const product_variant of c56) {
                          const forloop = fl57
                          let combined_variant_name = "";
                          const c58 = product.sorted_property_values
                          const fl59 = new CF2ForloopDrop(c58.length)
                          for (const property_values of c58) {
                            const forloop = fl59
                            const index0 = forloop?.index0;
                            const property_id = property_values?.property_id;
                            const property_value_id = product_variant?.property_value_ids?.[index0];
                            if (combined_variant_name != "") {
                              combined_variant_name = combined_variant_name.toString().concat(", ");
                            }
                            combined_variant_name = combined_variant_name.toString().concat(product.all_properties[property_id]);
                            combined_variant_name = combined_variant_name.toString().concat(": ");
                            combined_variant_name = combined_variant_name.toString().concat(product.all_properties_values[property_value_id]);
                            forloop.next();
                          }
                          html += `<option value="${product_variant?.property_value_ids}" `
                          if (product_variant?.id == variant?.id) {
                            html += `selected`
                          }
                          html += `>${combined_variant_name}</option>`
                          forloop.next();
                        }
                        html += `</select></div>`
                      }
                      if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                        const c60 = variant.prices
                        const fl61 = new CF2ForloopDrop(c60.length)
                        for (const price of c60) {
                          const forloop = fl61
                          html += `<option `
                          if (selected_price?.id == price?.id) {
                            html += `selected`
                          }
                          html += ` value="${price?.id}">${price?.name}</option>`
                          forloop.next();
                        }
                        html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                      }
                    }
                    html += `</div>`
                  }
                  html += `</div>`
                  forloop.next();
                }
                html += `</div></div>`
                if (can_purchase_again) {
                  html += `<div class="elProductCardNewOrderWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.purchaseAgain}</span><div></div></div><div class="elProductCardNewOrder`
                  if (newOrder == true) {
                    html += ` elProductCardOrderSelected`
                  }
                  html += `"><div class="elProductCardNewOrderTitle"><i class="fas fa-plus-circle"></i><span>${otherTexts?.upgradesDowngradesReactivations?.newOrder}</span></div>`
                  if (newOrder == true) {
                    html += `<div class="elProductCardOrderActions">`
                    if (variantDisplay != "individual") {
                      if (customVariants?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper">`
                        const c62 = product.sorted_property_values
                        const fl63 = new CF2ForloopDrop(c62.length)
                        for (const property_values of c62) {
                          const forloop = fl63
                          const property_id = property_values?.property_id;
                          const select_index = forloop?.index0;
                          html += `    `
                          html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                          const c64 = property_values.value_ids
                          const fl65 = new CF2ForloopDrop(c64.length)
                          for (const value_id of c64) {
                            const forloop = fl65
                            html += `<option `
                            if (variant?.property_value_ids?.[select_index] == value_id) {
                              html += `selected`
                            }
                            html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                            forloop.next();
                          }
                          html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                          forloop.next();
                        }
                        html += `</div>`
                      }
                    }
                    if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                      html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                      const c66 = variant.prices
                      const fl67 = new CF2ForloopDrop(c66.length)
                      for (const price of c66) {
                        const forloop = fl67
                        html += `<option `
                        if (selected_price?.id == price?.id) {
                          html += `selected`
                        }
                        html += ` value="${price?.id}">${price?.name}</option>`
                        forloop.next();
                      }
                      html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                    }
                    html += `</div>`
                  }
                  html += `</div></div>`
                }
                html += `</div>`
              }
            }
          }
        } else {
          html += `<div class="elProductLayoutBackground"></div>`
          if (selectType == "quantity") {
            html += `<div class="elProductInputWrapper elProductCardQuantityContainer"><div class="elProductInputControls"><button class="elProductCardInput">-</button><input class="elProductCardInput elProductCardShortInput" name="product" value="${quantity ?? 0}" min="0" type="number"/><button class="elProductCardInput">+</button></div></div>`
          } else if (selectType == "quantity-forced") {
            html += `<div class="elProductInputWrapper elSelectWrapper elForcedQuantityWrapper"><select name="product" class="elProductCardInput elProductInputControls">`
            const step = product?.step ?? 2;
            const min = product?.min ?? 0;
            const max = product?.max ?? 5;
            const item_count_step_1 = max- min;
            const item_count_step_2 = item_count_step_1/ step;
            const item_count_step_3 = item_count_step_2| 0;
            const range = Array.apply(0, Array(item_count_step_3)).map((element, index) => index + 0);;
            const c68 = range
            const fl69 = new CF2ForloopDrop(c68.length)
            for (const i of c68) {
              const forloop = fl69
              const value = i* step+ min;
              html += `<option value="${value}">${value}</option>`
              forloop.next();
            }
            html += `</select><div class="elSelectArrow elForcedQuantitySelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
          }
          const isClassic = layout == "classic";
          const isQuantityType = selectType == "quantity";
          html += `<div class="elProductCardSelectInput`
          if (isClassic == false || isQuantityType == true) {
            html += ` hide`
          }
          html += `">`
          if (selectType == "single") {
            if (isChecked) {
              html += `<div data-page-element="Radio/V1" class="elRadioWrapper id-Radio/V1" data-liquid-replace="item" data-checked="true" data-trigger-click-on-wrapper="false"><label class="elRadioLabel"><input type="radio" value="" name="product" checked class="elRadioInput"/><div class="elRadio"><div class="elRadioIcon"></div></div><span class="elRadioText"></span></label></div>`
            } else {
              html += `<div data-page-element="Radio/V1" class="elRadioWrapper id-Radio/V1" data-liquid-replace="item" data-checked="" data-trigger-click-on-wrapper="false"><label class="elRadioLabel"><input type="radio" value="" name="product"  class="elRadioInput"/><div class="elRadio"><div class="elRadioIcon"></div></div><span class="elRadioText"></span></label></div>`
            }
          } else if (selectType == "multiple" || selectType == "quantity") {
            if (isChecked) {
              html += `<div data-page-element="Checkbox/V1" type="custom_type" class="elCheckboxWrapper elFormItemWrapper de-input-block id-Checkbox/V1" data-content="" data-liquid-replace="item" data-prevent-click-on-label="false" data-trigger-click-on-wrapper="false" data-checked="true"><label class="elCheckboxLabel"><input type="checkbox" value="${product?.id}" name="product" checked data-prevent-garlic="false" class="elCheckboxInput inputHolder"/><div class="elCheckbox"><div class="elCheckboxIcon"><div class="elCheckboxIconSquare hide"></div><i class="elCheckboxIconCheck fas fa-check"></i></div></div><span class="elCheckboxText"></span></label><div data-input-status-type="true" data-error-container="true"></div></div>`
            } else {
              html += `<div data-page-element="Checkbox/V1" type="custom_type" class="elCheckboxWrapper elFormItemWrapper de-input-block id-Checkbox/V1" data-content="" data-liquid-replace="item" data-prevent-click-on-label="false" data-trigger-click-on-wrapper="false" data-checked=""><label class="elCheckboxLabel"><input type="checkbox" value="${product?.id}" name="product"  data-prevent-garlic="false" class="elCheckboxInput inputHolder"/><div class="elCheckbox"><div class="elCheckboxIcon"><div class="elCheckboxIconSquare hide"></div><i class="elCheckboxIconCheck fas fa-check"></i></div></div><span class="elCheckboxText"></span></label><div data-input-status-type="true" data-error-container="true"></div></div>`
            }
          }
          html += `</div>`
          if (showImage) {
            const imageUrl = variant?.image ?? product.image;
            if (imageUrl && imageUrl != "") {
              html += `<div class="elProductCardImage"><div data-page-element="Image/V2" class="elImageWrapper de-image-block id-Image/V2`
              if (true && CF2Blank( imageUrl ) && CF2Blank( null ) && false == false) {
                html += ` forceHide`
              }
              html += `" data-liquid-replace="item">`
              if (imageUrl || !CF2Blank( null )) {
                html += `<img class="elImage" src="${imageUrl ?? null}" data-lazy-loading="true"/>`
              } else if (false) {
                html += `<div class="image-placeholder" title=""><span class="image-placeholder-header"></span></div>`
              }
              html += `</div></div>`
            }
          }
          html += `<div class="elProductCardNameContainer">`
          if (featured && highlight_text) {
            html += `<div class="elProductCardHighlight">${highlight_text}</div>`
          }
          if (variantDisplay == "individual") {
            html += `<span class="elProductCardInfoName">${variant?.name}</span>`
          } else if (customVariants?.length > 1) {
            html += `<span class="elProductCardInfoName">${product?.default_variant?.name}</span>`
          } else {
            html += `<span class="elProductCardInfoName">${variant?.name}</span>`
          }
          if (showDescription) {
            html += `<span class="elProductCardInfoDescription">${(product?.description_override ?? variant.description ?? product.default_variant.description ?? "").replaceAll(`
`,"<br>")}</span>`
          }
          html += `</div>`
          html += `<div class="elProductCardPriceContainer">`
          if (priceDisplayType == "multiple") {
            if (variant?.prices?.length == 1) {
              html += `<div class="elProductCardInfoPrice">`
              if (showCompareAtPrice) {
                const compare_at_amount = selected_price?.compare_at_amount;
                if (compare_at_amount) {
                  html += `<span class="elProductCardAnchorPrice">${compare_at_amount}</span>`
                }
              }
              html += `<span class="elProductCardFinalPrice">${selected_price?.name}</span></div>`
            } else {
              html += `<div class="elSelectWrapper"><select name="variant_price">`
              const c70 = variant.prices
              const fl71 = new CF2ForloopDrop(c70.length)
              for (const price of c70) {
                const forloop = fl71
                html += `<option `
                if (selected_price?.id == price?.id) {
                  html += `selected`
                }
                html += ` value="${price?.id}">${price?.name}</option>`
                forloop.next();
              }
              html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
            }
          } else if (priceDisplayType == "single") {
            html += `<div class="elProductCardInfoPrice">`
            if (showCompareAtPrice) {
              const compare_at_amount = selected_price?.compare_at_amount;
              if (compare_at_amount) {
                html += `<span class="elProductCardAnchorPrice">${compare_at_amount}</span>`
              }
            }
            html += `<span class="elProductCardFinalPrice">${selected_price?.name}</span></div>`
          }
          html += `</div>`
          if (showProductVariantSelection && variantDisplay != "individual") {
            if (customVariants?.length > 1) {
              html += `<div class="elProductSelectSelectorsWrapper">`
              const c72 = product.sorted_property_values
              const fl73 = new CF2ForloopDrop(c72.length)
              for (const property_values of c72) {
                const forloop = fl73
                const property_id = property_values?.property_id;
                const select_index = forloop?.index0;
                html += `    `
                html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                const c74 = property_values.value_ids
                const fl75 = new CF2ForloopDrop(c74.length)
                for (const value_id of c74) {
                  const forloop = fl75
                  html += `<option `
                  if (variant?.property_value_ids?.[select_index] == value_id) {
                    html += `selected`
                  }
                  html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                  forloop.next();
                }
                html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                forloop.next();
              }
              html += `</div>`
            }
          }
          if (showManageOrders) {
            const amount_of_orders = updatableOrders?.length;
            if (amount_of_orders && amount_of_orders > 0) {
              if (variantDisplay == "individual") {
                const isCurrentPlan = individualDirection == "current";
                if (isCurrentPlan) {
                  html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i><span>Current plan</span>`
                  if (can_purchase_again) {
                    html += `<span class="elProductCardCurrentPlanSeparator">-</span>`
                    html += `<div class="elProductCardNewOrder elProductCardPurchaseAgainInline"><span>Purchase Again</span></div>`
                  }
                  html += `</div>`
                } else {
                  html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i><span>${individualDirection}</span></div>`
                  html += `<div class="elProductCardManageOrders`
                  if (CF2Blank( isChecked )) {
                    html += ` elHide`
                  }
                  html += `"><div class="elProductCardOrdersWrapper"><div class="elProductCardTitle"><span>${individualDirection} </span><div></div></div><div class="elProductCardOrders">`
                  const c76 = updatableOrders
                  const fl77 = new CF2ForloopDrop(c76.length)
                  for (const order of c76) {
                    const forloop = fl77
                    const orderIndex = forloop?.index0;
                    html += `<div class="elProductCardOrder`
                    if (selectedOrderIndex == orderIndex) {
                      html += ` elProductCardOrderSelected`
                    }
                    html += `" data-order-index="${orderIndex}"><div class="elProductCardOrderDetails"><div class="elProductCardOrderDetailsNumber"><i class="fas fa-receipt"></i><span>${otherTexts?.upgradesDowngradesReactivations?.order} ${order?.number}</span></div><span class="elProductCardOrderDetailsManage">${individualDirection}</span></div>`
                    if (selectedOrderIndex == orderIndex) {
                      html += `<div class="elProductCardOrderActions"><a data-page-element="LinkNode" class="elTypographyLink elProductCardShowOrderDetailsLink id-LinkNode" href="#show-selected-order-details" target="_self" data-show-button-ids="" data-hide-button-ids="" data-selected="${false}" data-liquid-replace="item"><span>${otherTexts?.upgradesDowngradesReactivations?.viewOrderDetails}</span></a><span class="elProductCardDirectionBadge">${individualDirection}  ${variant?.name} - ${selected_price?.name}</span></div>`
                    }
                    html += `</div>`
                    forloop.next();
                  }
                  html += `</div></div>`
                  if (can_purchase_again) {
                    html += `<div class="elProductCardNewOrderWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.purchaseAgain}</span><div></div></div><div class="elProductCardNewOrder`
                    if (newOrder == true) {
                      html += ` elProductCardOrderSelected`
                    }
                    html += `"><div class="elProductCardNewOrderTitle"><i class="fas fa-plus-circle"></i><span>${otherTexts?.upgradesDowngradesReactivations?.newOrder}</span></div>`
                    if (newOrder == true) {
                      html += `<div class="elProductCardOrderActions">`
                      if (variantDisplay != "individual") {
                        if (customVariants?.length > 1) {
                          html += `<div class="elProductSelectSelectorsWrapper">`
                          const c78 = product.sorted_property_values
                          const fl79 = new CF2ForloopDrop(c78.length)
                          for (const property_values of c78) {
                            const forloop = fl79
                            const property_id = property_values?.property_id;
                            const select_index = forloop?.index0;
                            html += `    `
                            html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                            const c80 = property_values.value_ids
                            const fl81 = new CF2ForloopDrop(c80.length)
                            for (const value_id of c80) {
                              const forloop = fl81
                              html += `<option `
                              if (variant?.property_value_ids?.[select_index] == value_id) {
                                html += `selected`
                              }
                              html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                              forloop.next();
                            }
                            html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                            forloop.next();
                          }
                          html += `</div>`
                        }
                      }
                      if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                        const c82 = variant.prices
                        const fl83 = new CF2ForloopDrop(c82.length)
                        for (const price of c82) {
                          const forloop = fl83
                          html += `<option `
                          if (selected_price?.id == price?.id) {
                            html += `selected`
                          }
                          html += ` value="${price?.id}">${price?.name}</option>`
                          forloop.next();
                        }
                        html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                      }
                      html += `</div>`
                    }
                    html += `</div></div>`
                  }
                  html += `</div>`
                }
              } else {
                let active_order = false;
                let canceled_order = false;
                const amount_of_orders = updatableOrders?.length;
                const c84 = updatableOrders
                const fl85 = new CF2ForloopDrop(c84.length)
                for (const order of c84) {
                  const forloop = fl85
                  if (order?.type == "reactivate") {
                    canceled_order = true;
                  } else {
                    active_order = true;
                  }
                  forloop.next();
                }
                html += `<div class="elProductCardSubscriptionsBanner"><i class="fas fa-sync-alt"></i>`
                if (active_order && canceled_order) {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.multipleExistingSubscriptions}</span>`
                  } else {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.singleExistingSubscription}</span>`
                  }
                } else if (canceled_order) {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} </span>`
                  } else {
                    html += `<span>${amount_of_orders} </span>`
                  }
                } else {
                  if (amount_of_orders > 1) {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.multipleActiveSubscriptions}</span>`
                  } else {
                    html += `<span>${amount_of_orders} ${otherTexts?.upgradesDowngradesReactivations?.singleActiveSubscription}</span>`
                  }
                }
                html += `</div>`
                html += `<div class="elProductCardManageOrders`
                if (CF2Blank( isChecked )) {
                  html += ` elHide`
                }
                html += `"><div class="elProductCardOrdersWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.manageSubscriptions}</span><div></div></div><div class="elProductCardOrders">`
                const c86 = updatableOrders
                const fl87 = new CF2ForloopDrop(c86.length)
                for (const order of c86) {
                  const forloop = fl87
                  const orderIndex = forloop?.index0;
                  html += `<div class="elProductCardOrder`
                  if (selectedOrderIndex == orderIndex) {
                    html += ` elProductCardOrderSelected`
                  }
                  html += `" data-order-index="${orderIndex}"><div class="elProductCardOrderDetails"><div class="elProductCardOrderDetailsNumber"><i class="fas fa-receipt"></i><span>${otherTexts?.upgradesDowngradesReactivations?.order} ${order?.number}</span></div>`
                  if (order?.type == "reactivate") {
                    html += `<span class="elProductCardOrderDetailsReactivate"></span>`
                  } else {
                    html += `<span class="elProductCardOrderDetailsManage">${otherTexts?.upgradesDowngradesReactivations?.manage}</span>`
                  }
                  html += `</div>`
                  if (selectedOrderIndex == orderIndex) {
                    html += `<div class="elProductCardOrderActions"><a data-page-element="LinkNode" class="elTypographyLink elProductCardShowOrderDetailsLink id-LinkNode" href="#show-selected-order-details" target="_self" data-show-button-ids="" data-hide-button-ids="" data-selected="${false}" data-liquid-replace="item"><span>${otherTexts?.upgradesDowngradesReactivations?.viewOrderDetails}</span></a>`
                    if (order?.type == "upgradeDowngrade") {
                      const updatableItem = order?.updatableItems?.[selectedUpdatableCartItemIndex];
                      html += `<div class="elCustomSelect"><div class="elCustomSelectPreview"><span class="elCustomSelectPreviewText"><span class="elCustomSelectPreviewDirection" data-direction="${updatableItem?.direction}">${updatableItem?.direction} </span><span class="elCustomSelectPreviewInfo">${updatableItem?.variantName} - ${updatableItem?.priceName}</span></span><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div><select name="upgradeDowngrade">`
                      const c88 = order.updatableItems
                      const fl89 = new CF2ForloopDrop(c88.length)
                      for (const updatableItem of c88) {
                        const forloop = fl89
                        const index = forloop?.index0;
                        html += `<option `
                        if (index == selectedUpdatableCartItemIndex) {
                          html += `selected`
                        }
                        html += ` value="${index}">${updatableItem?.direction}  ${updatableItem?.variantName} - ${updatableItem?.priceName}</option>`
                        forloop.next();
                      }
                      html += `</select></div>`
                    } else {
                      if (customVariants?.length > 1) {
                        html += `<div class="elCustomSelect"><div class="elCustomSelectPreview"><span class="elCustomSelectPreviewText"><span class="elCustomSelectPreviewDirection" data-direction="Reactivate"></span><span class="elCustomSelectPreviewInfo">${variant?.name}</span></span><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div><select class="elVariantSelector">`
                        const c90 = product.variants
                        const fl91 = new CF2ForloopDrop(c90.length)
                        for (const product_variant of c90) {
                          const forloop = fl91
                          let combined_variant_name = "";
                          const c92 = product.sorted_property_values
                          const fl93 = new CF2ForloopDrop(c92.length)
                          for (const property_values of c92) {
                            const forloop = fl93
                            const index0 = forloop?.index0;
                            const property_id = property_values?.property_id;
                            const property_value_id = product_variant?.property_value_ids?.[index0];
                            if (combined_variant_name != "") {
                              combined_variant_name = combined_variant_name.toString().concat(", ");
                            }
                            combined_variant_name = combined_variant_name.toString().concat(product.all_properties[property_id]);
                            combined_variant_name = combined_variant_name.toString().concat(": ");
                            combined_variant_name = combined_variant_name.toString().concat(product.all_properties_values[property_value_id]);
                            forloop.next();
                          }
                          html += `<option value="${product_variant?.property_value_ids}" `
                          if (product_variant?.id == variant?.id) {
                            html += `selected`
                          }
                          html += `>${combined_variant_name}</option>`
                          forloop.next();
                        }
                        html += `</select></div>`
                      }
                      if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                        const c94 = variant.prices
                        const fl95 = new CF2ForloopDrop(c94.length)
                        for (const price of c94) {
                          const forloop = fl95
                          html += `<option `
                          if (selected_price?.id == price?.id) {
                            html += `selected`
                          }
                          html += ` value="${price?.id}">${price?.name}</option>`
                          forloop.next();
                        }
                        html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                      }
                    }
                    html += `</div>`
                  }
                  html += `</div>`
                  forloop.next();
                }
                html += `</div></div>`
                if (can_purchase_again) {
                  html += `<div class="elProductCardNewOrderWrapper"><div class="elProductCardTitle"><span>${otherTexts?.upgradesDowngradesReactivations?.purchaseAgain}</span><div></div></div><div class="elProductCardNewOrder`
                  if (newOrder == true) {
                    html += ` elProductCardOrderSelected`
                  }
                  html += `"><div class="elProductCardNewOrderTitle"><i class="fas fa-plus-circle"></i><span>${otherTexts?.upgradesDowngradesReactivations?.newOrder}</span></div>`
                  if (newOrder == true) {
                    html += `<div class="elProductCardOrderActions">`
                    if (variantDisplay != "individual") {
                      if (customVariants?.length > 1) {
                        html += `<div class="elProductSelectSelectorsWrapper">`
                        const c96 = product.sorted_property_values
                        const fl97 = new CF2ForloopDrop(c96.length)
                        for (const property_values of c96) {
                          const forloop = fl97
                          const property_id = property_values?.property_id;
                          const select_index = forloop?.index0;
                          html += `    `
                          html += `<div class="elSelectWrapper"><select class="elVariantSelector" name="property_${property_id}">`
                          const c98 = property_values.value_ids
                          const fl99 = new CF2ForloopDrop(c98.length)
                          for (const value_id of c98) {
                            const forloop = fl99
                            html += `<option `
                            if (variant?.property_value_ids?.[select_index] == value_id) {
                              html += `selected`
                            }
                            html += ` value="${value_id}">${product?.all_properties_values?.[value_id]}</option>`
                            forloop.next();
                          }
                          html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div>`
                          forloop.next();
                        }
                        html += `</div>`
                      }
                    }
                    if (priceDisplayType == "single" && variant?.prices?.length > 1) {
                      html += `<div class="elProductSelectSelectorsWrapper"><div class="elSelectWrapper"><select name="variant_price">`
                      const c100 = variant.prices
                      const fl101 = new CF2ForloopDrop(c100.length)
                      for (const price of c100) {
                        const forloop = fl101
                        html += `<option `
                        if (selected_price?.id == price?.id) {
                          html += `selected`
                        }
                        html += ` value="${price?.id}">${price?.name}</option>`
                        forloop.next();
                      }
                      html += `</select><div class="elSelectArrow"><i class="fas fa-chevron-down"></i></div></div></div>`
                    }
                    html += `</div>`
                  }
                  html += `</div></div>`
                }
                html += `</div>`
              }
            }
          }
        }

      }

      this.replaceContent(html) 

      if (initializeChildrenInstances) {
        const scopeToYggRender = this.element.querySelectorAll('[ygg-render]').length > 0;
        const options = { scopeToYggRender };
        CF2Component.hydrateTree(this.element, options);
      }
    }


}

registerComponent('CheckoutProductCard/V2', CheckoutProductCardV2)
window["CheckoutProductCardV2"] = CheckoutProductCardV2

